module.exports = __webpack_public_path__ + "img/circle-thin.01eb81b0.svg";